import {
  DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_BEGIN,
  DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_SUCCESS,
  DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_FAILURE,
  DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
export function loadExternalApisExternalDb(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_BEGIN,
    });
    const { projectId, version, externalDatabaseId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/all/project`;
      if (externalDatabaseId) {
        url += `?externalDatabaseId=${externalDatabaseId}`;
      }

      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadExternalApisExternalDbError() {
  return {
    type: DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_BEGIN:
      return {
        ...state,
        loadExternalApisExternalDbPending: true,
        loadExternalApisExternalDbError: null,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_SUCCESS:
      return {
        ...state,
        loadExternalApisExternalDbPending: false,
        loadExternalApisExternalDbError: null,
        externalApisExternalDataSources: action.data,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_FAILURE:
      return {
        ...state,
        loadExternalApisExternalDbPending: false,
        loadExternalApisExternalDbError: action.data.error,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_DISMISS_ERROR:
      return {
        ...state,
        loadExternalApisExternalDbError: null,
      };

    default:
      return state;
  }
}
